export const removePhoneNonNumericCharacter = (phoneNumb: string): string => {
  return phoneNumb.replace(/[\s()-]+/g, '');
};
